module.exports = __webpack_public_path__ + "static/media/icon-filterTable-grey.cf4084df.svg";